"use strict";
// import crypto from 'crypto-js';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hash = void 0;
var Hash = /** @class */ (function () {
    function Hash() {
    }
    // static sha1(sorce: any): string {
    //   const convert = crypto.SHA1(JSON.stringify(sorce));
    //   return convert.toString();
    // }
    Hash.base64Encode = function (str) {
        return Buffer.from(str, 'binary').toString('base64');
    };
    Hash.base64Decode = function (str) {
        return Buffer.from(str, 'base64').toString('binary');
    };
    return Hash;
}());
exports.Hash = Hash;
